import { RootState } from '../store'

export const reportsCommonSelector = (state: RootState) => {
  const { reportsCommon } = state

  return reportsCommon
}
